module.exports = __webpack_public_path__ + "static/media/footer-logo.326d7abb.svg";